import React, { useEffect, useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { brandName, checkoutUrl, price } from '../data/copy';
import { trackPixelEvent } from '../utils/metaPixel';

/**
 * Atajo de compra siempre visible en pantallas pequeñas: aparece al pasar el
 * encabezado y se oculta sobre la sección de oferta.
 *
 * La visibilidad se controla con IntersectionObserver (sin lecturas de layout
 * en cada scroll), así que nunca fuerza un reflujo sincrónico.
 */
export function StickyCta() {
  const [isPastHero, setIsPastHero] = useState(false);
  const [isOnOffer, setIsOnOffer] = useState(false);
  useEffect(() => {
    const hero = document.querySelector('header');
    const offer = document.getElementById('oferta');
    const heroObserver = new IntersectionObserver(([entry]) => setIsPastHero(!entry.isIntersecting), {
      threshold: 0
    });
    if (hero) heroObserver.observe(hero);
    const offerObserver = new IntersectionObserver(([entry]) => setIsOnOffer(entry.isIntersecting), {
      threshold: 0
    });
    if (offer) offerObserver.observe(offer);
    return () => {
      heroObserver.disconnect();
      offerObserver.disconnect();
    };
  }, []);
  const isVisible = isPastHero && !isOnOffer;
  return <div className={`fixed inset-x-0 bottom-0 z-40 border-t border-line bg-card px-4 py-3 transition-[opacity,transform] duration-200 ease-out sm:hidden ${isVisible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-3 opacity-0'}`} data-id="element-179" data-mp="gx9zs88buvdz">
      <a href={checkoutUrl} onClick={() => trackPixelEvent('InitiateCheckout', {
      content_name: brandName,
      value: 19,
      currency: 'EUR'
    })} className="flex w-full items-center justify-center gap-2.5 rounded-full bg-accent px-6 py-3.5 font-sans text-[13px] font-bold uppercase tracking-[0.12em] text-white transition-colors duration-150 ease-out hover:bg-accent-hover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent" data-id="element-180" data-mp="lv1x5hrqr9pk">
        Accedi subito — {price}
        <ArrowRightIcon className="h-4 w-4" strokeWidth={2.2} aria-hidden="true" data-id="element-181" data-mp="10kqaw63p9n23" />
      </a>
    </div>;
}